// extracted by mini-css-extract-plugin
export var actionButton = "_g6-t";
export var buttonContainer = "_g6-0";
export var buttonContainer2 = "_g6-1";
export var buttonSection = "_g6-2";
export var details = "_g6-3";
export var dropdownItem = "_g6-5";
export var dropdownItemsContainer = "_g6-4";
export var fileInput = "_g6-r";
export var headerButton = "_g6-6";
export var icon = "_g6-7";
export var input = "_g6-8";
export var macroListItem = "_g6-9";
export var mainContent = "_g6-a";
export var microText = "_g6-b";
export var modal = "_g6-w";
export var optionsButton = "_g6-c";
export var paperclip = "_g6-s";
export var pillContent = "_g6-d";
export var preview = "_g6-e";
export var preview2 = "_g6-f";
export var quillEditor = "_g6-q";
export var selectedMacro = "_g6-g";
export var sidebar = "_g6-h";
export var sidebarHeader = "_g6-j";
export var sidebarList = "_g6-i";
export var sidebarListItem = "_g6-k";
export var sidebarSearch = "_g6-l";
export var snoozeDurationWrapper = "_g6-v";
export var statusPillContainer = "_g6-m";
export var tagsContainer = "_g6-n";
export var unselectedMacro = "_g6-o";
export var variable = "_g6-u";
export var wrapper = "_g6-p";